/**
 * 로딩 다이얼로그를 띄운다.
 * @param open true: 열기, false: 닫기
 * @param num 현재 진행된 개수
 * @param total 전체 개수
 * @param unit 단위
 */
export function loading(open = false, num = 0, total = 0, unit = "") {
  const loadingDialog = new CustomEvent("loadingDialog", {
    detail: {
      open,
      num,
      total,
      unit
    },
  });
  window.dispatchEvent(loadingDialog);
}
